import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyAsmDV740NgGdP001kIym5ta6jVcGSO5Ug",
  authDomain: "unimates-4fe71.firebaseapp.com",
  projectId: "unimates-4fe71",
  storageBucket: "unimates-4fe71.appspot.com",
  messagingSenderId: "10859239525",
  appId: "1:10859239525:web:425e6417f4730040260e8c",
  measurementId: "G-1M9NW07YM0"
};

firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const auth = firebase.auth();

export { firestore, auth  };

